module.exports = __webpack_public_path__ + "img/bg_vline.0d149101.svg";